import DeviceDetector from "device-detector-js";

export type DeviceInfo = {
  device_id: string | null;
  device_type: string | undefined;
  os: string | undefined;
  os_version: string | undefined;
  browser: string | undefined;
  browser_version: string | undefined;
  app_version: string | undefined;
  language: string | undefined;
};

export function getDeviceInformation(deviceId: string | null): DeviceInfo {
  const detector = new DeviceDetector();
  const parsed = detector.parse(navigator.userAgent);
  return {
    device_id: deviceId,
    device_type: parsed.device?.type,
    os: parsed.os?.name,
    os_version: parsed.os?.version,
    app_version: parsed.client?.version,
    browser: parsed.client?.name,
    browser_version: parsed.client?.version,
    language: navigator.language || undefined,
  };
}
